import React, { Component } from "react";
import RequestLoader from "../../spinner/index";
import "../../containers/DefaultLayout/profile/index.css";
import { configuration } from "../../appConfig";
import Axios from "axios";
import { Button } from "reactstrap";
import FormGroup from "reactstrap/lib/FormGroup";
import blueStart from "./png/sign.png";
import meter from "./png/meter.png";
import blackRim from "./png/black-wheel.png";
import whiteRim from "./png/white-wheel.png";
import Label from "reactstrap/lib/Label";
import Input from "reactstrap/lib/Input";
import sun from "./png/sun.png";
import cloudsun from "./png/cloud-sun.png";
import moon from "./png/moon.png";
import scanstart from "./png/scan-start.jpg";
import scanstop from "./png/scan-stop.png";
import crossSvg from "./png/No_sign.svg";
import setfarbe from "./png/set-farbe.png";
import licht from "./png/licht-removebg.png";
import resetbtn from "./png/reset.png";
import reseEmilFrey from "./png/emil_frey.png";
import CustomInput from "reactstrap/lib/CustomInput";
import { connect } from 'react-redux';
// import "./AppInterface.css";
import "./AppInterface_new.css";
import Card from "reactstrap/lib/Card";
import Cheif from '../../assets/img/brand/chief-logo.png'
import CheifLogo from '../../assets/img/brand/chie-logo-inner.png'

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class AppInterFace extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputSelected: '',
      vin: false,
      qr: false,
      showRedBorder: true,
      validateLoader:false,
      numberPlate: true,
      startScan: false,
      appInterFaceAccess : localStorage.getItem('appInterfaceAccess') === 'true' ? true : false,
      userNameForm:'',
      error: [],
      passwordForm:'',
      adminControl: false,
      vinNumberSeventeenCharacter: "",
      vinNumberSixCharacter: "",
      scanTime: "24 Seconds",
      colorData: [
        {
            "color": "#fafafa",
            "value": "White",
            "clicked": false
        },
        {
            "color": "#DBDBDB",
            "value": "Silver",
            "clicked": false
        },
        {
            "color": "#C3C361",
            "value": "YellowGreen",
            "clicked": false
        },
        {
            "color": "#C9A834",
            "value": "YellowOrange",
            "clicked": false
        },
        {
            "color": "#EB9200",
            "value": "Orange",
            "clicked": false
        },
        {
            "color": "#30A532",
            "value": "Green",
            "clicked": false
        },
        {
            "color": "#AC4C00",
            "value": "DarkOrange",
            "clicked": false
        },
        {
            "color": "#807C7B",
            "value": "Grey",
            "clicked": false
        },
        {
            "color": "#94090C",
            "value": "Red",
            "clicked": false
        },
        {
            "color": "#161595",
            "value": "Blue",
            "clicked": false
        },
        {
            "color": "#420A0B",
            "value": "Brown",
            "clicked": false
        },
        {
            "color": "#172B12",
            "value": "DarkGreen",
            "clicked": false
        },
        {
            "color": "#0A0B44",
            "value": "DarkBlue",
            "clicked": false
        },
        {
            "color": "black",
            "value": "Black",
            "clicked": false
        }
    ],
      color: "Black",
      displayColor: "",
      words: {},
      lang: props.lang,
      toggle_btn_loader: "",
      partner_id: localStorage.getItem("partnerId"),
      camera: false,
      lights: false,
      apiLoader: false,
      loading: true,
      buttonsDisabled: false,
      dayLight: "100",
      blackRim: false,
      initialNumber: "",
      secondaryNumber: "",
      thirdNumber: "",
      whiteRim: false,
    };
    this.vinNumberSixCharacterRef = React.createRef()
    this.vinNumberSeventeenCharacterRef = React.createRef()
    this.regNoInitialRef = React.createRef()
    this.regNoSecondaryRef = React.createRef()
    this.regNoThirdRef = React.createRef()
  }

  async componentDidMount () {
    await this.getAppInterfaceStatus();
    if(this.state.vin){
      if(localStorage.getItem("partnerId") ==="10-200410"){
        this.vinNumberSixCharacterRef.current.focus()
      }else{
        this.vinNumberSeventeenCharacterRef.current.focus()
      }
    }else if(this.state.numberPlate){
      if(this.state.initialNumber.length === 3 && this.state.appInterFaceAccess){
        this.setState({inputSelected:2})
        this.regNoSecondaryRef.current.focus()
        if(this.state.secondaryNumber.length === 2){
          this.setState({inputSelected:3})
          this.regNoThirdRef.current.focus()
        }
      }else if(this.state.appInterFaceAccess){
        this.setState({inputSelected:1})
        this.regNoInitialRef.current.focus()
      }
    }
    this.getLang()
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };

  getAppInterfaceStatus = async () => {
    let partnerId = this.state.partner_id;
    const url = configuration.getAppInterfaceStatus;
    if (partnerId) {
      const response = await Axios.get(url + "?partnerId=" + partnerId)
        // =7-200406
        .then((res) => {
          let updatedColor = []
          if (res.data && res.data.success !== "false") {
            if(res.data.color !== ''){
              updatedColor = this.state.colorData.map(color => {
                if(color.value === res.data.color){
                  color.clicked = true
                } 
                return color
              })
            }
            let displayColor = this.state.colorData.filter(
              (item) => item.value === res.data.color
            );
            let vin 
            if(res.data.registrationType === 'VIN' && res.data.registrationType !== '' && this.state.partner_id === "10-200410" && res.data.vin !== ''){
              vin = res.data.vin
              this.setState({
                vinNumberSixCharacter : vin,
                showRedBorder: false,
              })
            }else{
              this.setState({
                showRedBorder: true
              })
            }
            if(res.data.registrationType === 'VIN' && res.data.registrationType !== '' && res.data.vin !== ''){
              // this.vinNumberSeventeenCharacterRef.current.focus();
              vin = res.data.vin
              if(res.data.vin.length === 17){
                this.setState({
                  vinNumberSeventeenCharacter : vin,
                  showRedBorder: false,
                })
              }
            }else{
              this.setState({
                showRedBorder: true
              })
            }
            if(res.data.registrationType === 'RegNo' && res.data.registrationType !== '' && res.data.vin !== ''){
              // let regNo = res.data.vin;
              // let initialNumber
              // let secondaryNumber
              // let thirdNumber
              // if (regNo.length == 9) {
              //   initialNumber = res.data.vin.slice(0,3)
              //   secondaryNumber = res.data.vin.slice(3,5)
              //   thirdNumber = res.data.vin.slice(5)
              // }
              // else if (regNo.length == 8) {
              //   initialNumber = res.data.vin.slice(0,2)
              //   secondaryNumber = res.data.vin.slice(2,4)
              //   thirdNumber = res.data.vin.slice(4)
              // }
              // else if (regNo.length == 7) {
              //   initialNumber = res.data.vin.slice(0,1)
              //   secondaryNumber = res.data.vin.slice(1,3)
              //   thirdNumber = res.data.vin.slice(3)
              // }
              // else {
              //   initialNumber = res.data.vin.slice(0,3)
              //   secondaryNumber = res.data.vin.slice(3,5)
              //   thirdNumber = res.data.vin.slice(5)
              // }
              
              // this.setState({
              //   initialNumber,secondaryNumber,thirdNumber,
              //   showRedBorder: false,
              // })
              if(res.data.segment_1 === null && res.data.segment_2 === null && res.data.segment_3 === null){
                this.setState({
                  initialNumber : '',
                  secondaryNumber : '',
                  thirdNumber : '',
                  showRedBorder: false,  
                }) 
              }
              if(res.data.segment_2 === '-'){
                this.setState({
                  initialNumber : res.data.segment_1,
                  secondaryNumber : '',
                  thirdNumber : res.data.segment_3,
                  showRedBorder: false,  
                }) 
              }else{
                this.setState({
                  initialNumber : res.data.segment_1,
                  secondaryNumber : res.data.segment_2,
                  thirdNumber : res.data.segment_3,
                  showRedBorder: false,  
                })              
              }
            }else{
              this.setState({
                showRedBorder: true
              })
            }
            if (res.data.lastAccessedOn !== null) {
              let lastAccessedOn = parseInt(res.data.lastAccessedOn);
              let Time = new Date();
              let currentTime = Time.getTime();
              if (currentTime - lastAccessedOn >= 300000) {
                this.setState({
                  colorData : updatedColor,
                  vinNumber: res.data.vin,
                  vin: res.data.registrationType === 'VIN' ? true : false,
                  numberPlate: res.data.registrationType === 'RegNo' ? true : false,
                  startScan : res.data.startScan === true ? true : false,
                  camera: res.data.turnOnCameras,
                  lights: res.data.turnOnLights,
                  color: res.data.color,
                  displayColor: displayColor[0].color,
                  blackRim: res.data.rimColor === "Dark" ? true : false,
                  whiteRim: res.data.rimColor === "Bright" ? true : false,
                  scanTime: `${res.data.scanTime} Seconds`,
                  buttonsDisabled: true,
                  loading: false,
                  dayLight: res.data.dayLight,
                  showRedBorder: res.data.registrationType === 'VIN' ? 
                  localStorage.getItem("partnerId") ==="10-200410" ? res.data.vin.length === 6 ? false : true : res.data.vin.length === 17 ? false : true 
                  : (res.data.registrationType === 'RegNo' && res.data.segment_1 !== null && res.data.segment_3 !== null) ?
                  (res.data.segment_1.length >= 1 && res.data.segment_3.length >= 1) ? false : true : true              ,
                });
              } else {
                this.setState({
                  colorData : updatedColor,
                  startScan : res.data.startScan === true ? true : false,
                  vin: res.data.registrationType === 'VIN' ? true : false,
                  numberPlate: res.data.registrationType === 'RegNo' ? true : false,
                  dayLight: res.data.dayLight,
                  vinNumber: res.data.vin,
                  camera: res.data.turnOnCameras,
                  displayColor: displayColor[0].color,
                  blackRim: res.data.rimColor === "Dark" ? true : false,
                  whiteRim: res.data.rimColor === "Bright" ? true : false,
                  lights: res.data.turnOnLights,
                  color: res.data.color,
                  scanTime: `${res.data.scanTime} Seconds`.trim(),
                  loading: false,
                  buttonsDisabled: false,
                  showRedBorder: res.data.registrationType === 'VIN' ? 
                  localStorage.getItem("partnerId") ==="10-200410" ? res.data.vin.length === 6 ? false : true : res.data.vin.length === 17 ? false : true 
                  : (res.data.registrationType === 'RegNo' && res.data.segment_1 !== null && res.data.segment_3 !== null) ?
                  (res.data.segment_1.length >= 1 && res.data.segment_3.length >= 1) ? false : true : true
                });
              }
            } else {
              this.setState({
                colorData : updatedColor,
                vinNumber: res.data.vin,
                vin: res.data.registrationType === 'VIN' ? true : false,
                numberPlate: res.data.registrationType === 'RegNo' ? true : false,
                startScan : res.data.startScan === true ? true : false,
                dayLight: res.data.dayLight,
                displayColor: displayColor[0].color,
                blackRim: res.data.rimColor === "Dark" ? true : false,
                whiteRim: res.data.rimColor === "Bright" ? true : false,
                camera: res.data.turnOnCameras,
                lights: res.data.turnOnLights,
                scanTime: `${res.data.scanTime} Seconds`.trim(),
                color: res.data.color,
                loading: false,
                buttonsDisabled: false,
                showRedBorder: res.data.registrationType === 'VIN' ? 
                  localStorage.getItem("partnerId") ==="10-200410" ? res.data.vin.length === 6 ? false : true : res.data.vin.length === 17 ? false : true 
                  : (res.data.registrationType === 'RegNo' && res.data.segment_1 !== null && res.data.segment_3 !== null) ?
                  (res.data.segment_1.length >= 1 && res.data.segment_3.length >= 1) ? false : true : true
              });
            }
          } else {
            this.setState({
              vinNumber: "",
              camera: false,
              lights: false,
              color: "Black",
              scanTime: `12 Seconds`.trim(),
              loading: false,
              buttonsDisabled: false,
            });
          }
        })
        .catch((err) => {
          alert("Something went wrong please try again later")
        });
    } else {
      this.props.history.push("/login");
    }
  };

  setLoginLoader = () => {
    this.setState({
      validateLoader: !this.state.validateLoader
    })
  }

  validateAppInterface = () =>{
    this.setLoginLoader()
    let error = []
    if(!this.state.passwordForm.trim()){
      error.push('passwordFormError')
    }
    if(!this.state.userNameForm.trim()){
      error.push('userNameFormError')
    }
    this.setState({error})
    if(error.length === 0){
      let request = {
        partnerId: this.state.partner_id,
        username: this.state.userNameForm,
        password: this.state.passwordForm
      }
      Axios.post(configuration.validateAppInterface,request).then((res) => {
        this.setLoginLoader()
        if(res.data.success === "true"){
          this.setState({appInterFaceAccess:true})
          localStorage.setItem('appInterfaceAccess',true)
        }else{
          alert(res.data.message)
          localStorage.setItem('appInterfaceAccess',false)
        }
        // this.setState({
        //   words: res.data,
        //   lang: localStorage.getItem("lang"),
        // });
      }).catch(err=>{
        localStorage.setItem('appInterfaceAccess',false)
        this.setLoginLoader()
        alert(err)
      });
    }
  }

  setRim = (event) => {
    if (event.target.id === "blackRim") {
      this.setState({
        blackRim: true,
        whiteRim: false,
      });
    } else {
      this.setState({
        blackRim: false,
        whiteRim: true,
      });
    }
  };

  // generateBackground(rangeElement) {
  //   if (this.rangeElement.value === this.options.min) {
  //     return
  //   }
  //   let percentage =  (this.rangeElement.value - this.options.min) / (this.options.max - this.options.min) * 100
  //   return 'background: linear-gradient(to right, #50299c, #7a00ff ' + percentage + '%, #d3edff ' + percentage + '%, #dee1e2 100%)'
  // }
  showRedBorder = () => {
    if(this.state.vin){
      if(localStorage.getItem("partnerId") ==="10-200410"){
        if(this.state.vinNumberSixCharacter.length === 6){
          this.setState({
            showRedBorder: false,
          })
        }else{
          this.setState({
            showRedBorder: true,
          })
        }
      }else{
        if(this.state.vinNumberSeventeenCharacter.length === 17){
          this.setState({
            showRedBorder: false,
          })
        }else{
          this.setState({
            showRedBorder: true,
          })
        }
      }
    }
    if(this.state.numberPlate){
      if(this.state.inputSelected === 1){
        if(this.state.initialNumber.length === 3){
          this.regNoSecondaryRef.current.focus()
        }
      }
      if(this.state.inputSelected === 2){
        if(this.state.secondaryNumber.length === 2){
          this.regNoThirdRef.current.focus()
        }
      }
      if(this.state.inputSelected === 3){
        if(this.state.thirdNumber.length === 0){
          this.regNoSecondaryRef.current.focus()
        }
      }
      if( this.state.initialNumber.length >= 1 && 
        this.state.thirdNumber.length >= 1
      ){
      this.setState({
        showRedBorder: false,
      })
    }else{
      this.setState({
        showRedBorder: true,
      })
    }
    }
  }
  handleChange = (event) => {
    if(event.target.name === 'dayLight'){
      this.setState({
        [event.target.name]: event.target.value,
      });
    }else if(event.target.name ==='secondaryNumber'){
      if(event.target.value.length >= 3){
        let value = this.state.secondaryNumber.slice(0,2)
        this.setState({secondaryNumber:value},()=>{
          this.showRedBorder()
        })
      }else{
        this.setState({
          [event.target.name]: event.target.value,
        }, ()=> {
          this.showRedBorder()
        });
      }
    }else if(event.target.name ==='initialNumber'){
      if(event.target.value.length >= 4){
        let value = this.state.initialNumber.slice(0,3)
        this.setState({initialNumber:value},()=>{
          this.showRedBorder()
        })
      }else{
        this.setState({
          [event.target.name]: event.target.value,
        }, ()=> {
          this.showRedBorder()
        });
      }
    }else if(event.target.name ==='thirdNumber'){
      if(event.target.value.length >= 6){
        let value = this.state.thirdNumber.slice(0,5)
        this.setState({thirdNumber:value},()=>{
          this.showRedBorder()
        })
      }else{
        this.setState({
          [event.target.name]: event.target.value,
        }, ()=> {
          this.showRedBorder()
        });
      }
    }else if(event.target.name ==='vinNumberSeventeenCharacter'){
      if(event.target.value.length >= 18){
        let value = this.state.vinNumberSeventeenCharacter.slice(0,17)
        this.setState({vinNumberSeventeenCharacter:value},()=>{
          this.showRedBorder()
        })
      }else{
        this.setState({
          [event.target.name]: event.target.value,
        }, ()=> {
          this.showRedBorder()
        });
      }
    }else if(event.target.name ==='vinNumberSixCharacter'){
      if(event.target.value.length >= 7){
        let value = this.state.vinNumberSixCharacter.slice(0,6)
        this.setState({vinNumberSixCharacter:value},()=>{
          this.showRedBorder()
        })
      }else{
        this.setState({
          [event.target.name]: event.target.value,
        }, ()=> {
          this.showRedBorder()
        });
      }
    }else{
      this.setState({
        [event.target.name]: event.target.value,
      }, ()=> {
        this.showRedBorder()
      });
    }
    // this.showRedBorder()
  };

  setAdmin = () =>{
    this.setState({
      adminControl:!this.state.adminControl,
    })
  }

  setCategory = (event) => {
    if (event.target.id === "numberPlate") {
      this.setState({
        numberPlate: true,
        vinNumberSeventeenCharacter: '',
        vinNumberSixCharacter: '',
        showRedBorder: true,
        vin: false,
        qr: false
      });
    }
    else if(event.target.id === "qr"){
      this.setState({
        initialNumber: '',
        secondaryNumber: '',
        vinNumberSeventeenCharacter : '',
        vinNumberSixCharacter: '',
        showRedBorder: false,
        thirdNumber: '',
        qr: true,
        numberPlate: false,
        vin: false
      });
    }
    else {
      this.setState({
        initialNumber: '',
        secondaryNumber: '',
        showRedBorder: true,
        thirdNumber: '',
        vin: true,
        numberPlate: false,
        qr: false
      });
    }
  };

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  switchSelect = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
    if(event.target.name === 'camera'){
      this.setState({ [event.target.name]: event.target.checked },()=>{this.setCameraStatus()});
    }else if(event.target.name === 'lights'){
      this.setState({ [event.target.name]: event.target.checked },()=>{this.setLightStatus()});
    }
  };

  resetState = async (evt) => {
    this.setState({ toggle_btn_loader: true });
    evt.preventDefault();
    let request = {
      partnerId: this.state.partner_id,
    };
    let partnerId = this.state.partner_id;
    const url = configuration.resetInterfaceStatus;
    if (partnerId) {
      const response = await Axios.post(url, request)
        .then((res) => {
          if (res.data.success === "true") {
            this.setState({
              toggle_btn_loader: false,
              vinNumber: "",
              scanTime: "",
              partner_id: localStorage.getItem("partnerId"),
              camera: false,
              lights: false,
              color: "Black",
              showRedBorder: true,
              vinNumberSeventeenCharacter: '',
              vinNumberSixCharacter: "",
              initialNumber: '',
              secondaryNumber: '',
              thirdNumber: ''
            });
            this.getAppInterfaceStatus();
          } else {
            alert("Something went wrong!");
          }
        })
        .catch((err) => {
          this.setState({ toggle_btn_loader: false });
          alert("Something went wrong please try again later");
        });
    } else {
      this.props.history.push("/login");
    }
  };

  resetStateScan = async (evt) => {
    this.setState({ toggle_btn_loader: true });
    let request = {
      partnerId: this.state.partner_id,
    };
    let partnerId = this.state.partner_id;
    const url = configuration.resetInterfaceStatus;
    if (partnerId) {
      const response = await Axios.post(url, request)
        .then((res) => {
          if (res.data.success === "true") {
            this.setState({
              toggle_btn_loader: false,
              vinNumber: "",
              scanTime: "",
              partner_id: localStorage.getItem("partnerId"),
              camera: false,
              lights: false,
              showRedBorder: true,
              color: "Black",
              vinNumberSeventeenCharacter: '',
              vinNumberSixCharacter: "",
              initialNumber: '',
              secondaryNumber: '',
              thirdNumber: ''
            });
            this.getAppInterfaceStatus();
          } else {
            alert("Something went wrong!");
          }
        })
        .catch((err) => {
          this.setState({ toggle_btn_loader: false });
          alert("Something went wrong please try again later");
        });
    } else {
      this.props.history.push("/login");
    }
  };

  setColor = async (evt) => {
    evt.preventDefault();
    let partnerId = this.state.partner_id;
    if (this.state.numberPlate) {
      this.setState({ toggle_btn_loader: true });
      const url = configuration.postAppInterfaceColorStatus
      let request = {
        partnerId: partnerId,
        color: this.state.color,
     }
      const response = await Axios.post(url, request)
        .then((res) => {
          if (res.data.success === "true") {
            this.setState({ toggle_btn_loader: false,});
          } else if (res.data.success === "false" && res.data.message === "Expected data missing.") {
            this.setState({ toggle_btn_loader: false });
            alert("Expected Data Missing");
          }else if (res.data.success === "false" && res.data.message === "Internal Server Error. Please try again later.") {
            this.setState({ toggle_btn_loader: false });
            alert("Internal Server Error. Please try again later.");
          }
          this.getAppInterfaceStatus()
        })
        .catch((err) => {
          this.setState({ toggle_btn_loader: false });
          alert("Something went wrong please try again later");
        });
    //   if (
    //     !this.state.initialNumber.trim() || !this.state.initialNumber.length >= 1 ||
    //     !this.state.thirdNumber.trim() || !this.state.thirdNumber.length >= 1
    //   ) {
    //     alert("Please enter the License Plate");
    //     return;
    //   }
    //   this.setState({ toggle_btn_loader: true });
    //   let vin =
    //     this.state.initialNumber +
    //     this.state.secondaryNumber +
    //     this.state.thirdNumber;
    //   let request = {
    //     segment_1: this.state.initialNumber.toUpperCase(),
    //     segment_2: this.state.secondaryNumber.length === 0 ? '-' : this.state.secondaryNumber.toUpperCase(),
    //     segment_3: this.state.thirdNumber.toUpperCase(),
    //     vin : vin.toUpperCase(),
    //     registrationType: 'RegNo',
    //     turnOnCameras: this.state.camera,
    //     turnOnLights: this.state.lights,
    //     startScan: false,
    //     partnerId: this.state.partner_id,
    //     scanTime: this.state.scanTime.split(" ")[0],
    //     color: this.state.color,
    //     rimColor: this.state.blackRim ? "Dark" : "Bright",
    //     dayLight: this.state.dayLight,
    //     stopScan: false,
    //   };
    //   const url = configuration.postAppInterfaceStatus;
    //   if (partnerId) {
    //     const response = await Axios.post(url, request)
    //       .then((res) => {
    //         if (res.data.message === "Expected data missing.") {
    //           alert("Something went wrong please try again later");
    //         }
    //         if (res.data.success === "true") {
    //           this.setState({ toggle_btn_loader: false, startScan: false });
    //         } else if (res.data.success === "false") {
    //           this.setState({ toggle_btn_loader: false });
    //           alert("Something went wrong please try again later");
    //         }
    //       })
    //       .catch((err) => {
    //         this.setState({ toggle_btn_loader: false });
    //         alert("Something went wrong please try again later");
    //       });
    //   } else {
    //     this.props.history.push("/login");
    //   }
    // }
    // if (this.state.vin) {
    //   if (this.state.partner_id === '"10-200410"') {
    //     if (!this.state.vinNumberSixCharacter.trim() || this.state.vinNumberSixCharacter.trim().length < 6) {
    //       alert("Please enter Vin Number");
    //       return;
    //     }
    //     this.setState({ toggle_btn_loader: true });
    //     let vin = this.state.vinNumberSixCharacter;
    //     let request = {
    //       segment_1: null,
    //       segment_2: null,
    //       segment_3: null,
    //       vin: vin.toUpperCase(),
    //       registrationType: 'VIN',
    //       turnOnCameras: this.state.camera,
    //       turnOnLights: this.state.lights,
    //       startScan: false,
    //       partnerId: this.state.partner_id,
    //       scanTime: this.state.scanTime.split(" ")[0],
    //       color: this.state.color,
    //       rimColor: this.state.blackRim ? "Dark" : "Bright",
    //       dayLight: this.state.dayLight,
    //       stopScan: false,
    //     };
    //     const url = configuration.postAppInterfaceStatus;
    //     if (partnerId) {
    //       const response = await Axios.post(url, request)
    //         .then((res) => {
    //           if (res.data.message === "Expected data missing.") {
    //             alert("Something went wrong please try again later");
    //           }
    //           if (res.data.success === "true") {
    //             this.setState({ toggle_btn_loader: false, startScan: false });
    //           } else if (res.data.success === "false") {
    //             this.setState({ toggle_btn_loader: false });
    //             alert("Something went wrong please try again later");
    //           }
    //         })
    //         .catch((err) => {
    //           this.setState({ toggle_btn_loader: false });
    //           alert("Something went wrong please try again later");
    //         });
    //     } else {
    //       this.props.history.push("/login");
    //     }
    //   } else {
    //     if (!this.state.vinNumberSeventeenCharacter.trim() || this.state.vinNumberSeventeenCharacter.trim().length < 17) {
    //       alert("Please Enter the Vin Number");
    //       return;
    //     }
    //     this.setState({ toggle_btn_loader: true });
    //     let vin = this.state.vinNumberSeventeenCharacter;
    //     let request = {
    //       vin: vin.toUpperCase(),
    //       segment_1: null,
    //       segment_2: null,
    //       segment_3: null,
    //       registrationType: 'VIN',
    //       turnOnCameras: this.state.camera,
    //       turnOnLights: this.state.lights,
    //       startScan: false,
    //       partnerId: this.state.partner_id,
    //       scanTime: this.state.scanTime.split(" ")[0],
    //       color: this.state.color,
    //       rimColor: this.state.blackRim ? "Dark" : "Bright",
    //       dayLight: this.state.dayLight,
    //       stopScan: false,
    //     };
    //     const url = configuration.postAppInterfaceStatus;
    //     if (partnerId) {
    //       const response = await Axios.post(url, request)
    //         .then((res) => {
    //           if (res.data.message === "Expected data missing.") {
    //             alert("Something went wrong please try again later");
    //           }
    //           if (res.data.success === "true") {
    //             this.setState({ toggle_btn_loader: false, startScan: false });
    //           } else if (res.data.success === "false") {
    //             this.setState({ toggle_btn_loader: false });
    //             alert("Something went wrong please try again later");
    //           }
    //         })
    //         .catch((err) => {
    //           this.setState({ toggle_btn_loader: false });
    //           alert("Something went wrong please try again later");
    //         });
    //     } else {
    //       this.props.history.push("/login");
    //     }
    //   }
    }
  };

  setLights = async (evt) => {
    evt.preventDefault();
    let partnerId = this.state.partner_id;
    if (this.state.numberPlate) {
      if (
        !this.state.initialNumber.trim() || !this.state.initialNumber.length >= 1 ||
        !this.state.thirdNumber.trim() || !this.state.thirdNumber.length >= 1
      ) {
        alert("Please enter the License Plate");
        return;
      }
      this.setState({ toggle_btn_loader: true });
      let vin =
        this.state.initialNumber + '-' +
        this.state.secondaryNumber +
        this.state.thirdNumber;
      let request = {
        vin: vin.toUpperCase(),
        segment_1: this.state.initialNumber.toUpperCase(),
        segment_2: this.state.secondaryNumber.length === 0 ? '-' : this.state.secondaryNumber.toUpperCase(),
        segment_3: this.state.thirdNumber.toUpperCase(),
        registrationType: 'RegNo',
        turnOnCameras: this.state.camera,
        turnOnLights: this.state.lights,
        startScan: false,
        partnerId: this.state.partner_id,
        scanTime: this.state.scanTime.split(" ")[0],
        color: this.state.color,
        rimColor: this.state.blackRim ? "Dark" : "Bright",
        dayLight: this.state.dayLight,
        stopScan: false,
      };
      const url = configuration.postAppInterfaceStatus;
      if (partnerId) {
        const response = await Axios.post(url, request)
          .then((res) => {
            if (res.data.message === "Expected data missing.") {
              alert("Something went wrong please try again later");
            }
            if (res.data.success === "true") {
              this.setState({ toggle_btn_loader: false, startScan: false });
            } else if (res.data.success === "false") {
              this.setState({ toggle_btn_loader: false });
              alert("Something went wrong please try again later");
            }
          })
          .catch((err) => {
            this.setState({ toggle_btn_loader: false });
            alert("Something went wrong please try again later");
          });
      } else {
        this.props.history.push("/login");
      }
    }
    if (this.state.vin) {
      if (this.state.partner_id === '"10-200410"') {
        if (!this.state.vinNumberSixCharacter.trim() || this.state.vinNumberSixCharacter.trim().length < 6) {
          alert("Please enter Vin Number");
          return;
        }
        this.setState({ toggle_btn_loader: true });
        let vin = this.state.vinNumberSixCharacter;
        let request = {
          vin: vin.toUpperCase(),
          segment_1: null,
          segment_2: null,
          segment_3: null,
          registrationType: 'VIN',
          turnOnCameras: this.state.camera,
          turnOnLights: this.state.lights,
          startScan: false,
          partnerId: this.state.partner_id,
          scanTime: this.state.scanTime.split(" ")[0],
          color: this.state.color,
          rimColor: this.state.blackRim ? "Dark" : "Bright",
          dayLight: this.state.dayLight,
          stopScan: false,
        };
        const url = configuration.postAppInterfaceStatus;
        if (partnerId) {
          const response = await Axios.post(url, request)
            .then((res) => {
              if (res.data.message === "Expected data missing.") {
                alert("Something went wrong please try again later");
              }
              if (res.data.success === "true") {
                this.setState({ toggle_btn_loader: false, startScan: false });
              } else if (res.data.success === "false") {
                this.setState({ toggle_btn_loader: false });
                alert("Something went wrong please try again later");
              }
            })
            .catch((err) => {
              this.setState({ toggle_btn_loader: false });
              alert("Something went wrong please try again later");
            });
        } else {
          this.props.history.push("/login");
        }
      } else {
        if (!this.state.vinNumberSeventeenCharacter.trim() || this.state.vinNumberSeventeenCharacter.trim().length < 17) {
          alert("Please Enter the Vin Number");
          return;
        }
        this.setState({ toggle_btn_loader: true });
        let vin = this.state.vinNumberSeventeenCharacter;
        let request = {
          vin: vin.toUpperCase(),
          segment_1: null,
          segment_2: null,
          segment_3: null,
          registrationType: 'VIN',
          turnOnCameras: this.state.camera,
          turnOnLights: this.state.lights,
          startScan: false,
          partnerId: this.state.partner_id,
          scanTime: this.state.scanTime.split(" ")[0],
          color: this.state.color,
          rimColor: this.state.blackRim ? "Dark" : "Bright",
          dayLight: this.state.dayLight,
          stopScan: false,
        };
        const url = configuration.postAppInterfaceStatus;
        if (partnerId) {
          const response = await Axios.post(url, request)
            .then((res) => {
              if (res.data.message === "Expected data missing.") {
                alert("Something went wrong please try again later");
              }
              if (res.data.success === "true") {
                this.setState({ toggle_btn_loader: false, startScan: false });
              } else if (res.data.success === "false") {
                this.setState({ toggle_btn_loader: false });
                alert("Something went wrong please try again later");
              }
            })
            .catch((err) => {
              this.setState({ toggle_btn_loader: false });
              alert("Something went wrong please try again later");
            });
        } else {
          this.props.history.push("/login");
        }
      }
    }
  };

  setLightStatus = async () =>{
    this.setState({ toggle_btn_loader: true });
    const url = configuration.setLightStatus;
    let request = {
      partnerId: this.state.partner_id,
      turnOnLights: this.state.lights,
      turnOnCameras: this.state.camera
   }
    const response = await Axios.post(url, request)
      .then((res) => {
        if (res.data.success === "true") {
          this.setState({ toggle_btn_loader: false,});
        } else if (res.data.success === "false" && res.data.message === "Expected data missing.") {
          this.setState({ toggle_btn_loader: false });
          alert("Expected Data Missing");
        }else if (res.data.success === "false" && res.data.message === "Internal Server Error. Please try again later.") {
          this.setState({ toggle_btn_loader: false });
          alert("Internal Server Error. Please try again later.");
        }
        this.getAppInterfaceStatus()
      })
      .catch((err) => {
        this.setState({ toggle_btn_loader: false });
        alert("Something went wrong please try again later");
      });
  }

  setCameraStatus = async () =>{
    this.setState({ toggle_btn_loader: true });
    const url = configuration.setLightStatus;
    let request = {
      partnerId: this.state.partner_id,
      turnOnLights: this.state.lights,
      turnOnCameras: this.state.camera
   }
    const response = await Axios.post(url, request)
      .then((res) => {
        if (res.data.success === "true") {
          this.setState({ toggle_btn_loader: false,});
        } else if (res.data.success === "false" && res.data.message === "Expected data missing.") {
          this.setState({ toggle_btn_loader: false });
          alert("Expected Data Missing");
        }else if (res.data.success === "false" && res.data.message === "Internal Server Error. Please try again later.") {
          this.setState({ toggle_btn_loader: false });
          alert("Internal Server Error. Please try again later.");
        }
        this.getAppInterfaceStatus()
      })
      .catch((err) => {
        this.setState({ toggle_btn_loader: false });
        alert("Something went wrong please try again later");
      });
  }

  setColorState = (index) => {
    let colorValueToState = this.state.colorData[index].value;
    let clickedColor = this.state.colorData.map((item) => {
      if (item.value === this.state.colorData[index].value) {
        item.clicked = true;
      } else {
        item.clicked = false;
      }
      return item;
    });
    this.setState({
      color: colorValueToState,
      colorData: clickedColor,
      displayColor: this.state.colorData[index].color,
    });
  };

  stopScan = async () => {
    let partnerId = this.state.partner_id;
    if (this.state.numberPlate) {
      this.setState({ apiLoader: true });
      let vin =
        this.state.initialNumber + '-' +
        this.state.secondaryNumber +
        this.state.thirdNumber;
      let request = {
        segment_1: this.state.initialNumber.toUpperCase(),
        segment_2: this.state.secondaryNumber.length === 0 ? '-' : this.state.secondaryNumber.toUpperCase(),
        segment_3: this.state.thirdNumber.toUpperCase(),
        vin: vin.toUpperCase(),
        turnOnCameras: this.state.camera,
        registrationType: 'RegNo',
        turnOnLights: this.state.lights,
        startScan: false,
        partnerId: this.state.partner_id,
        scanTime: this.state.scanTime.split(" ")[0],
        color: this.state.color,
        rimColor: this.state.blackRim ? "Dark" : "Bright",
        dayLight: this.state.dayLight,
        stopScan: true,
      };
      const url = configuration.postAppInterfaceStatus;
      if (partnerId) {
        const response = await Axios.post(url, request)
          .then((res) => {
            if (res.data.message === "Expected data missing.") {
              alert("Something went wrong please try again later");
            }
            if (res.data.success === "true") {
              this.setState({ apiLoader: false, startScan: false });
            } else if (res.data.success === "false") {
              this.setState({ apiLoader: false });
              alert("Something went wrong please try again later");
            }
          })
          .catch((err) => {
            this.setState({ apiLoader: false });
            alert("Something went wrong please try again later");
          });
      } else {
        this.props.history.push("/login");
      }
    }
    if (this.state.vin) {
      if (this.state.partner_id === '"10-200410"') {
        this.setState({ apiLoader: true });
        let vin = this.state.vinNumberSixCharacter;
        let request = {
          vin: vin.toUpperCase(),
          segment_1: null,
          segment_2: null,
          segment_3: null,
          registrationType: 'VIN',
          turnOnCameras: this.state.camera,
          turnOnLights: this.state.lights,
          startScan: false,
          partnerId: this.state.partner_id,
          scanTime: this.state.scanTime.split(" ")[0],
          color: this.state.color,
          rimColor: this.state.blackRim ? "Dark" : "Bright",
          dayLight: this.state.dayLight,
          stopScan: true,
        };
        const url = configuration.postAppInterfaceStatus;
        if (partnerId) {
          const response = await Axios.post(url, request)
            .then((res) => {
              if (res.data.message === "Expected data missing.") {
                alert("Something went wrong please try again later");
              }
              if (res.data.success === "true") {
                this.setState({ apiLoader: false, startScan: false });
              } else if (res.data.success === "false") {
                this.setState({ apiLoader: false });
                alert("Something went wrong please try again later");
              }
            })
            .catch((err) => {
              this.setState({ apiLoader: false });
              alert("Something went wrong please try again later");
            });
        } else {
          this.props.history.push("/login");
        }
      } else {
        this.setState({ apiLoader: true });
        let vin = this.state.vinNumberSeventeenCharacter;
        let request = {
          vin: vin.toUpperCase(),
          segment_1: null,
          segment_2: null,
          segment_3: null,
          registrationType: 'VIN',
          turnOnCameras: this.state.camera,
          turnOnLights: this.state.lights,
          startScan: false,
          partnerId: this.state.partner_id,
          scanTime: this.state.scanTime.split(" ")[0],
          color: this.state.color,
          rimColor: this.state.blackRim ? "Dark" : "Bright",
          dayLight: this.state.dayLight,
          stopScan: true,
        };
        const url = configuration.postAppInterfaceStatus;
        if (partnerId) {
          const response = await Axios.post(url, request)
            .then((res) => {
              if (res.data.message === "Expected data missing.") {
                alert("Something went wrong please try again later");
              }
              if (res.data.success === "true") {
                this.setState({ apiLoader: false, startScan: false });
              } else if (res.data.success === "false") {
                this.setState({ apiLoader: false });
                alert("Something went wrong please try again later");
              }
            })
            .catch((err) => {
              this.setState({ apiLoader: false });
              alert("Something went wrong please try again later");
            });
        } else {
          this.props.history.push("/login");
        }
      }
    }
    this.getAppInterfaceStatus()
  };

  startScan = async () => {
    let partnerId = this.state.partner_id;
    if (this.state.numberPlate) {
      if (
        !this.state.initialNumber.trim() || !this.state.initialNumber.length >= 1 ||
        !this.state.thirdNumber.trim() || !this.state.thirdNumber.length >= 1
      ) {
        alert("Please enter the License Plate");
        return;
      }
      this.setState({ apiLoader: true });
      let vin =
        this.state.initialNumber + '-' +
        this.state.secondaryNumber +
        this.state.thirdNumber;
      let request = {
        vin : vin.toUpperCase(),
        segment_1: this.state.initialNumber.toUpperCase(),
        segment_2: this.state.secondaryNumber.length === 0 ? '-' : this.state.secondaryNumber.toUpperCase(),
        segment_3: this.state.thirdNumber.toUpperCase(),
        registrationType: 'RegNo',
        turnOnCameras: true,
        turnOnLights: true,
        startScan: true,
        partnerId: this.state.partner_id,
        scanTime: this.state.scanTime.split(" ")[0],
        color: this.state.color,
        rimColor: this.state.blackRim ? "Dark" : "Bright",
        dayLight: this.state.dayLight,
        stopScan: false,
      };
      const url = configuration.postAppInterfaceStatus;
      if (partnerId) {
        const response = await Axios.post(url, request)
          .then((res) => {
            if (res.data.message === "Expected data missing.") {
              alert("Something went wrong please try again later");
              return;
            }
            if (res.data.success === "true") {
              this.setState({ apiLoader: false, startScan: true });
            } else if (res.data.success === "false") {
              this.setState({ apiLoader: false });
              alert("Something went wrong please try again later");
            }
          })
          .catch((err) => {
            this.setState({ apiLoader: false });
            alert("Something went wrong please try again later");
          });
      } else {
        this.props.history.push("/login");
      }
      setTimeout(()=>{
        this.getAppInterfaceStatus()
       },parseInt(`${parseInt(this.state.scanTime.split(' ')[0])}000`));
    }
    if (this.state.vin) {
      if (this.state.partner_id === '"10-200410"') {
        if (!this.state.vinNumberSixCharacter.trim() || this.state.vinNumberSixCharacter.trim().length < 6) {
          alert("Please enter Vin Number");
          return;
        }
        this.setState({ apiLoader: true });
        let vin = this.state.vinNumberSixCharacter;
        let request = {
          segment_1: null,
          segment_2: null,
          segment_3: null,
          vin: vin.toUpperCase(),
          registrationType: 'VIN',
          turnOnCameras: true,
          turnOnLights: true,
          startScan: true,
          partnerId: this.state.partner_id,
          scanTime: this.state.scanTime.split(" ")[0],
          color: this.state.color,
          rimColor: this.state.blackRim ? "Dark" : "Bright",
          dayLight: this.state.dayLight,
          stopScan: false,
        };
        const url = configuration.postAppInterfaceStatus;
        if (partnerId) {
          const response = await Axios.post(url, request)
            .then((res) => {
              if (res.data.message === "Expected data missing.") {
                alert("Something went wrong please try again later");
              }
              if (res.data.success === "true") {
                this.setState({ apiLoader: false, startScan: true });
              } else if (res.data.success === "false") {
                this.setState({ apiLoader: false });
                alert("Something went wrong please try again later");
              }
            })
            .catch((err) => {
              this.setState({ apiLoader: false });
              alert("Something went wrong please try again later");
            });
        } else {
          this.props.history.push("/login");
        }
        setTimeout(()=>{
          this.getAppInterfaceStatus()
         },parseInt(`${parseInt(this.state.scanTime.split(' ')[0])}000`));
      } else {
        if (!this.state.vinNumberSeventeenCharacter.trim() || this.state.vinNumberSeventeenCharacter.trim().length < 17) {
          alert("Please Enter the Vin Number");
          return;
        }
        this.setState({ apiLoader: true });
        let vin = this.state.vinNumberSeventeenCharacter;
        let request = {
          segment_1: null,
          segment_2: null,
          segment_3: null,
          vin: vin.toUpperCase(),
          turnOnCameras: true,
          turnOnLights: true,
          registrationType: 'VIN',
          startScan: true,
          partnerId: this.state.partner_id,
          scanTime: this.state.scanTime.split(" ")[0],
          color: this.state.color,
          rimColor: this.state.blackRim ? "Dark" : "Bright",
          dayLight: this.state.dayLight,
          stopScan: false,
        };
        const url = configuration.postAppInterfaceStatus;
        if (partnerId) {
          const response = await Axios.post(url, request)
            .then((res) => {
              if (res.data.message === "Expected data missing.") {
                alert("Something went wrong please try again later");
              }
              if (res.data.success === "true") {
                this.setState({ apiLoader: false,startScan: true  });
              } else if (res.data.success === "false") {
                this.setState({ apiLoader: false});
                alert("Something went wrong please try again later");
              }
            })
            .catch((err) => {
              this.setState({ apiLoader: false });
              alert("Something went wrong please try again later");
            });
        } else {
          this.props.history.push("/login");
        }
        setTimeout(()=>{
          this.getAppInterfaceStatus()
         },parseInt(`${parseInt(this.state.scanTime.split(' ')[0])}000`));
      }
    }
    // let time = `${parseInt(this.state.scanTime.split(' ')[0])}000`
    // setTimeout(()=>{
    //   this.getAppInterfaceStatus()
    //  },parseInt(`${parseInt(this.state.scanTime.split(' ')[0])}000`));
    // Api integration for Qr radio button in
    if(this.state.qr){
      // validation
      if(this.state.vinNumberSixCharacter.trim()){
        alert("Please Don't Fill VIN number")
      }
      this.setState({ apiLoader: true });
      let request = { 
        registrationType : "AutoQRVIN",
        segment_1: null,
        segment_2: null,
        segment_3: null,
        vin: '',
        turnOnCameras: true,
        turnOnLights: true,
        startScan: true,
        partnerId: this.state.partner_id,
        color: this.state.color,
        scanTime: this.state.scanTime.split(" ")[0],

        rimColor: this.state.blackRim ? "Dark" : "Bright",
        dayLight: this.state.dayLight,
        stopScan: false,
      };
      
      const url = configuration.postAppInterfaceStatus;
        if (partnerId) {
          const response = await Axios.post(url, request)
            .then((res) => {
              if (res.data.message === "Expected data missing.") {
                alert("Something went wrong please try again later");
              }
              if (res.data.success === "true") {
                this.setState({ apiLoader: false,startScan: true  });
              } else if (res.data.success === "false") {
                this.setState({ apiLoader: false});
                alert("Something went wrong please try again later");
              }
            })
            .catch((err) => {
              this.setState({ apiLoader: false });
              alert("Something went wrong please try again later");
            });
        } else {
          this.props.history.push("/login");
        } 
        setTimeout(()=>{
          this.getAppInterfaceStatus()
         },parseInt(`${parseInt(this.state.scanTime.split(' ')[0])}000`));
    }
  };

  render() {
    const { vinNumber, scanTime } = this.state;
    let loginForm = (
      <div className="container mt-4">
        <div className="row mt-4">
          <div className="col-8 m-auto">
            <form
              className="FacSignupForm card"
              autoComplete="off"
            >
            <div className="text-center mt-4">
            {
              localStorage.getItem("partnerId") ==="10-200410" ?
              <>
                <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-sm-12 text-right p-0">
                    <img src={Cheif} className="chief_logo"/>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 text-left">
                  <h3
                    style={{
                      marginTop: "0.5rem",
                      fontWeight: "900",
                      margin: "0",
                      textAlign:"right",
                    }}
                  >
                    {this.lang("DnS Mobile App")}
                  </h3>
                </div>
                </div>
              </>
            :
            <div className="col-12 text-center">
              <h3
                style={{
                  marginTop: "0.5rem",
                  fontWeight: "900",
                  margin: "0",
                }}
              >
                {this.lang("DnS Mobile App")}
              </h3>
            </div>
            }
            </div>
              <div className="col-12">
                <div className="row mt-4 p-0">
                  <div className="col-lg-6">
                    <Label>{this.lang("Enter Your Username")}</Label>
                  </div>
                  <div className="col-lg-6">
                    <FormGroup>
                      <div className="dropdown mt-1">
                        <Input
                          type="text"
                          name="userNameForm"
                          onChange={this.onChange}
                          className="form-control p-2"
                          value={this.state.userNameForm}
                        />
                      </div>
                    </FormGroup>
                    {
                      this.state.error.includes('userNameFormError') && (
                        <div style={{color:'red'}}>
                          {this.lang("Please Enter your username")}
                        </div>
                      )
                    }
                  </div>
                </div>
                <div className="row mt-4 p-0">
                  <div className="col-lg-6">
                    <Label>{this.lang("Enter Your Password")}</Label>
                  </div>
                  <div className="col-lg-6">
                    <FormGroup>
                      <div className="dropdown mt-1">
                        <Input
                          type="password"
                          name="passwordForm"
                          onChange={this.onChange}
                          className="form-control p-2"
                          value={this.state.passwordForm}
                        />
                      </div>
                    </FormGroup>
                    {
                      this.state.error.includes('passwordFormError') && (
                        <div style={{color:'red'}}>
                          {this.lang("Please Enter your password")}
                        </div>
                      )
                    }
                  </div>
                </div>
                <div className="row justify-content-center mt-4 m-2">
                  <Button color="danger" className="m-2 btn-lg" onClick={this.validateAppInterface}>
                    {this.lang("Login")}
                  </Button>
                </div>
                {
                  this.state.validateLoader && (
                    <RequestLoader
                      size="40px"
                      style={{ marginTop: "1rem" }}
                    />
                  )
                }
              </div>
            </form>
          </div>
        </div>
      </div>
    )
    let appInterface = (
      <>
      <div className="container mt-3">
          <div className="row mt-1 mx-auto">
            <div className="col-12 col-lg-10 col-md-12 col-sm-12 mx-auto">
              <Card>
                <div className="row heading_main_app_interface align-items-center">
                  <div className="col-12">
                    <div className="row align-items-center">
                    <div className="col-12 text-center">
                    {this.state.buttonsDisabled && (
                      <h3 style={{ color: "red" }}>Please connect your app client</h3>
                    )}
                    </div>
                    {
                      localStorage.getItem("partnerId") ==="10-200410" ? 
                      <>
                        <div className="col-6 text-right p-0">
                            <img src={CheifLogo} />
                        </div>
                        <div className="col-6 col-lg-5 col-md-6 col-sm-6 text-left web_interface_text">
                          <h3
                            style={{
                              marginTop: "0.5rem",
                              fontWeight: "900",
                              margin: "0",
                              textAlign:"right",
                            }}
                          >
                           {this.lang("Dns Mobile App")}
                          </h3>
                        </div>
                      </>
                    : 
                    <div className="col-12 text-center">
                      <h3
                        style={{
                          marginTop: "0.5rem",
                          fontWeight: "900",
                          margin: "0",
                        }}
                      >
                        {this.lang("DnS Mobile App")}
                      </h3>
                    </div>
                    }
                        {/* <div className="col-6 text-right p-0">
                          <img src={reseEmilFrey} />
                        </div>
                        <div className="col-6 text-left">
                          <h3
                            style={{
                              marginTop: "0.5rem",
                              fontWeight: "900",
                              margin: "0",
                            }}
                          >
                            Web Interface
                          </h3>
                        </div> */}
                    </div>
                  </div>
                </div>
                <form>
                  <div className="row mb-5 back_white_rim">
                    <div className="col-12">
                      <div className="row p-0 count_row text-center align-items-center">
                        <div className="col-2 col-lg-2 col-md-2 col-sm-2 p-0 count_text">
                          <h1>1</h1>
                          <p>{this.lang('Auto')}</p>
                        </div>
                        <div className="col-1 col-lg-1 col-md-1 col-sm-1 text-center first_row_vin_no p-0"></div>
                        <div className="col-9 col-lg-6 col-md-9 col-sm-9 text-center first_row_vin_no p-0">
                          <div className="row">
                            <div className="col-6 col-lg-5 col-sm-4 input_lable_first_row text-left p-0">
                              <div className="radio">
                                <input
                                  type="radio"
                                  id="numberPlate"
                                  name="Category"
                                  onChange={this.setCategory}
                                  value="numberPlate"
                                  checked={this.state.numberPlate}
                                />
                                <label for="radio-1" className="radio-label">
                                  {this.lang('License_Plate')}
                                </label>
                              </div>
                            </div>
                            <div className="col-3 col-lg-4 col-sm-4 input_lable_first_row text-left p-0">
                              <div className="radio">
                                <input
                                  type="radio"
                                  id="vin"
                                  name="Category"
                                  onChange={this.setCategory}
                                  value="vin"
                                  checked={this.state.vin}
                                />
                                <label for="radio-1" className="radio-label">
                                  {this.lang("VIN")}
                                </label>
                              </div>
                            </div>
                            {/* QR */}
                            <div className="col-3 col-lg-3 col-sm-4 input_lable_first_row text-right vin_label p-0">
                              <div className="radio">
                                <input
                                  type="radio"
                                  id="qr"
                                  name="Category"
                                  onChange={this.setCategory}
                                  value="qr"
                                  checked={this.state.qr}
                                />
                                <label for="radio-1" className="radio-label">
                                  {this.lang("QR")}  
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 text-left p-0">
                              {this.state.numberPlate && (
                                <div className="numberPlate">
                                  <img
                                    className="blueStart"
                                    src={blueStart}
                                    alt="numberPlateImg"
                                  />
                                  <input
                                    onChange={this.handleChange}
                                    ref={this.regNoInitialRef}
                                    className="MMM"
                                    maxLength="3"
                                    autoFocus="true"
                                    onFocus={()=>this.setState({inputSelected:1})}
                                    type="text"
                                    value={this.state.initialNumber}
                                    name="initialNumber"
                                    placeholder="_ _ _"
                                    
                                  />
                                  <img
                                    className="meter"
                                    style={{
                                      width: "32px",
                                    }}
                                    src={meter}
                                    alt="numberPlateImg"
                                  />
                                  <input
                                    onChange={this.handleChange}
                                    ref={this.regNoSecondaryRef}
                                    onFocus={()=>this.setState({inputSelected:2})}
                                    className="MM"
                                    maxLength="2"
                                    type="text"
                                    value={this.state.secondaryNumber}
                                    name="secondaryNumber"
                                    placeholder="_ _"
                                    
                                  />
                                  <input
                                    onChange={this.handleChange}
                                    ref={this.regNoThirdRef}
                                    className="MMMM"
                                    onFocus={()=>this.setState({inputSelected:3})}
                                    value={this.state.thirdNumber}
                                    maxLength="5"
                                    type="text"
                                    name="thirdNumber"
                                    placeholder="_ _ _ _ _"
                                    
                                  />
                                </div>
                              )}
                              {this.state.vin && (
                                <div className="vinInput row align-items-center p-0">
                                  <div className="col-lg-4 col-md-2 col-sm-12 p-0">
                                    
                                    {
                                      localStorage.getItem("partnerId") ==="10-200410" ? 
                                      <p style={{ fontWeight: 700, padding:'0', margin:'0' }}> {this.lang('Last_6_digits')} </p>
                                    : <p style={{ fontWeight: 700 }}> {this.lang('17_digit')} </p>
                                    }
                                    
                                  </div>
                                  <div className="col-lg-8 col-md-10 col-sm-12 p-0">
                                    {localStorage.getItem("partnerId") ===
                                    "10-200410" ? (
                                      <>
                                      <div className="row p-0 align-items-center">
                                        <div className="col-2 p-0 text-center">
                                        <p className="xxx_class_text" style={{ fontWeight: 700, margin:"0", padding:"0", }}>XXX-</p>
                                        </div>
                                        <div className="col-10 p-0">
                                        <input
                                        type="text"
                                        placeholder="______"
                                        autoFocus="true"
                                        name="vinNumberSixCharacter"
                                        ref={this.vinNumberSixCharacterRef}
                                        className="vinNumberSixCharacter"
                                        value={this.state.vinNumberSixCharacter}
                                        maxLength="6"
                                        onChange={this.handleChange}
                                        
                                      />
                                        </div>
                                      </div>
                                      </>
                                    ) : (
                                      <div
                                        style={{ textAlign: "end" }}
                                        className="bottom_character_text"
                                      >
                                        <input
                                          type="text"
                                          placeholder="_________________"
                                          autoFocus="true"
                                          name="vinNumberSeventeenCharacter"
                                          ref={this.vinNumberSeventeenCharacterRef}
                                          value={this.state.vinNumberSeventeenCharacter}
                                          maxLength="17"
                                          onChange={this.handleChange}
                                          
                                          className="vinNumberSeventeenCharacter"
                                        />
                                        <div style={{display:"flex", justifyContent:"space-between"}}>
                                          <p
                                            style={{ fontSize: "10.5px",margin:"0" }}
                                            className="text-muted bottom_character_text"
                                          >
                                            {this.lang('Entered')}:{" "}
                                            {
                                              this.state
                                                .vinNumberSeventeenCharacter
                                                .length
                                            }{" "}
                                            {this.lang('digit')}
                                          </p>
                                          <p
                                            style={{ fontSize: "10.5px", margin:"0" }}
                                            className="text-muted bottom_character_text"
                                          >
                                            {this.lang('Still_missing')}:{" "}
                                            {17 -
                                              parseInt(
                                                this.state
                                                  .vinNumberSeventeenCharacter
                                                  .length
                                              )}{" "}
                                              {this.lang('digit')}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                              {/* input for Qr */}
                              {this.state.qr && (
                                <div className="vinInput row align-items-center p-0">
                                  <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                                      <div
                                        style={{ textAlign: "end" }}
                                        className="bottom_character_text"
                                      >
                                        <input
                                          type="text"
                                          placeholder="_________________"
                                          autoFocus="true"
                                          disabled={true}
                                          name="vinNumberSeventeenCharacter"
                                          // ref={this.vinNumberSeventeenCharacterRef}
                                          // value={this.state.vinNumberSeventeenCharacter}
                                          maxLength="0"
                                          // onChange={this.handleChange}
                                          
                                          className="vinNumberSeventeenCharacter"
                                        />  
                                      </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row justify-content-center p-0">
                        <div className="col-lg-9 col-md-12 col-sm-12 p-0">
                          <hr style={{margin:"0.3rem 0", borderTop:"1px solid rgb(0 0 0 / 50%)"}}/>
                        </div>
                      </div>
                      <div className="row p-0 count_row text-center align-items-center input_lable_first_row rim_main_row">
                        <div className="col-2 col-lg-2 col-md-2 col-sm-2 p-0 count_text">
                          <h1>2</h1>
                          <p>{this.lang('Rim')}</p>
                        </div>
                        <div className="col-1 col-lg-1 col-md-1 col-sm-1 text-center first_row_vin_no p-0"></div>
                        <div className="col-9 col-lg-6 col-md-9 col-sm-9 text-center first_row_vin_no p-0 blac_white_rim_input">
                          <div className="row">
                            <div className="col-6 p-0 input_lable_first_row text-left">
                              {/* <p style={{ fontSize: "16px" }}>Black</p> */}

                              <div className="radio1">
                                <div style={{ position: "relative" }}>
                                  <div className="rim_type_input left_input">
                                    <input
                                      type="radio"
                                      id="blackRim"
                                      name="rim"
                                      onChange={this.setRim}
                                      value="blackRim"
                                      checked={this.state.blackRim}
                                    />
                                    <span></span>
                                    {/* <label for="radio-1" className="radio-label">
                                    </label> */}
                                  </div>
                                <img
                                  className="rim"
                                  onClick={this.setRim}
                                  id="blackRim"
                                  src={blackRim}
                                  style={{cursor:'pointer'}}
                                  alt="blackRim"
                                />
                              </div>
                                </div>
                            </div>
                            <div className="col-6 p-0 input_lable_first_row text-right vin_label">
                              {/* <p style={{ fontSize: "16px" }}>White</p> */}
                              <div className="radio1">
                                <div style={{ position: "relative" }}>
                                  <div className="rim_type_input right_input">
                                    <input
                                      type="radio"
                                      id="whiteRim"
                                      name="rim"
                                      onChange={this.setRim}
                                      value="whiteRim"
                                      checked={this.state.whiteRim}
                                    />
                                    <span></span>
                                    {/* <label for="radio-1" className="radio-label">
                                    </label> */}
                                  </div>
                                <img
                                  className="rim"
                                  src={whiteRim}
                                  style={{cursor:'pointer'}}
                                  onClick={this.setRim}
                                  id="whiteRim"
                                  alt="whiteRim"
                                />
                              </div>
                                </div>
                                
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row justify-content-center p-0">
                        <div className="col-lg-9 col-md-12 col-sm-12 p-0">
                          <hr style={{margin:"0.3rem 0", borderTop:"1px solid rgb(0 0 0 / 50%)"}}/>
                        </div>
                      </div>
                      <div className="row p-0 count_row color_patten_row text-center align-items-center">
                        <div className="col-2 col-lg-2 col-md-2 col-sm-2 p-0 count_text">
                          <h1>3</h1>
                          <p>{this.lang('color')}</p>
                        </div>
                        <div className="col-1 col-lg-1 col-md-1 col-sm-1 text-center first_row_vin_no p-0"></div>
                        <div className="col-9 col-lg-6 col-md-9 col-sm-9 text-center first_row_vin_no p-0">
                          <div className="row">
                            <div className="col-12 p-0">
                              <ul className="color_list">
                                {this.state.colorData.map((color, index) => (
                                  <li
                                    className={
                                      color.clicked
                                        ? "color_box active"
                                        : "color_box"
                                    }
                                    onClick={() => this.setColorState(index)}
                                    style={{
                                      backgroundColor: `${color.color}`,
                                      opacity: color.clicked ? 1 : 1,
                                    }}
                                  ></li>
                                ))}
                              </ul>
                              <p style={{margin:'0',padding:'0', textTransform: 'capitalize'}}>{this.state.color}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row justify-content-center p-0">
                        <div className="col-lg-9 col-md-12 col-sm-12 p-0">
                          <hr style={{margin:"0.3rem 0", borderTop:"1px solid rgb(0 0 0 / 50%)"}}/>
                        </div>
                      </div>
                      <div className="row p-0 count_row text-center align-items-center">
                        <div className="col-2 col-lg-2 col-md-2 col-sm-1 p-0 count_text" style={{border:"none"}}>
                          <h1 style={{visibility:'hidden'}}>4</h1>
                          {/* <p>{this.lang('AMBIENT')}</p> */}
                        </div>
                        <div className="col-1 col-lg-1 col-md-1 col-sm-1 text-center first_row_vin_no p-0"></div>
                        <div className="col-9 col-lg-6 col-md-9 col-sm-9 text-center first_row_vin_no p-0">
                          <div className="row">
                            <div className="col-4 text-left p-0">
                              <img src={sun} className="dayligt_img" />
                            </div>
                            <div className="col-4 text-center p-0">
                              <img src={cloudsun} className="dayligt_img" />
                            </div>
                            <div className="col-4 text-right p-0">
                              <img src={moon} className="dayligt_img" />
                            </div>
                          </div>
                          <div className="row input_range_slide1 pt-0 pb-0">
                            <div className="col-12">
                                {/* <form>
                                <input type="range"
                                name="dayLight" className="slider" value={this.state.dayLight} onChange={this.handleChange}/>
                                </form> */}
                                {/* <form className="range">
                                  <div className="form-group range__slider">
                                    <input type="range"  name="dayLight" value={this.state.dayLight}  onChange={this.handleChange} />
                                  </div>
                                </form> */}
                                <input type="range" className='slider' step="10" name="dayLight" value={this.state.dayLight}  onChange={this.handleChange} />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row p-0 count_row mb-2 text-center align-items-center" >
                        <div className="col-2 col-lg-2 col-md-2 col-sm-2 p-0 count_text" style={{border:"none"}}>
                          <h1 style={{visibility:'hidden'}}>5</h1>
                          {/* <p>{this.lang('Go')}</p> */}
                        </div>
                        <div className="col-1 col-lg-1 col-md-1 col-sm-1 text-center first_row_vin_no p-0"></div>
                        <div className="col-9 col-lg-6 col-md-9 col-sm-9 text-center first_row_vin_no p-0">
                          <div className="row">
                            <div className="col">
                              {this.state.showRedBorder ? (
                                <img
                                  src={crossSvg}
                                  className="startbuttons"
                                  style={{
                                  cursor: "pointer",
                                  borderRadius: "100%",
                                  }}
                                />
                              ):
                              (
                                this.state.startScan ? (
                                <img
                                  src={scanstop}
                                  className="startbuttons"
                                  style={{
                                  cursor: "pointer",
                                  border: "5px solid red",
                                  borderRadius: "100%",
                                  }}
                                  onClick={this.stopScan}
                                />
                              ) : (
                                <img
                                  src={scanstart}
                                  className="startbuttons"
                                  style={{
                                    cursor: "pointer",
                                    border: this.state.showRedBorder ? "5px solid red" :"5px solid green",
                                    borderRadius: "100%",
                                  }}
                                  onClick={this.startScan}
                                />
                              )
                              )}
                            </div>
                          </div>
                          {this.state.apiLoader && (
                            <RequestLoader
                              size="40px"
                              style={{ marginTop: "1rem" }}
                            />
                          )}
                          {this.state.toggle_btn_loader && (
                            <RequestLoader
                              size="40px"
                              style={{ marginTop: "1rem" }}
                            />
                          )}
                        </div>
                      </div>

                      <div className="row p-0 mt-5 count_row admin_main_row text-center align-items-center">
                        <div className="col-2 col-lg-2 col-md-2 col-sm-2 p-0 count_text" style={{}}>
                          <p>Admin</p>
                          <input
                            // className="custom-control-input"
                            type="checkbox"
                            id="admin"
                            name="admin"
                            onChange={this.setAdmin}
                            value="admin"
                            checked={this.state.adminControl}
                          />
                        </div>
                        <div className="col-1 col-lg-1 col-md-1 col-sm-1 text-center first_row_vin_no p-0"></div>
                        <div className="col-9 col-lg-6 col-md-9 col-sm-9 text-center" style={{visibility:this.state.adminControl ? 'visible' :'hidden',opacity:this.state.adminControl ? '1' :'0'  }}>
                              <div className="row text-center first_switch_btn main_border_black">
                                <div className="col-12">
                                  <p className="admin_text_heading">Admin</p>
                                </div>
                                <div className="row justify-content-center">
                                  <div className="col-lg-9 col-md-11 col-sm-12">
                                    <div className="row p-0">
                                      <div className="col-6 p-0 text-left">
                                        <div className="checkbox switcher">
                                          <label for="camera">
                                            <input
                                              name="camera"
                                              type="checkbox"
                                              id="camera"
                                              value=""
                                              checked={this.state.camera}
                                              onChange={this.switchSelect}
                                            />
                                            <span>
                                              <small></small>
                                            </span>
                                          </label>
                                        </div>
                                        <p
                                          style={{
                                            marginBottom: "5px",
                                          }}
                                        >
                                          Camera
                                        </p>
                                      </div>

                                      <div className="col-6 p-0 text-right">
                                        <div className="checkbox switcher light_switch">
                                          <label for="lights">
                                            <input
                                              name="lights"
                                              type="checkbox"
                                              id="lights"
                                              value=""
                                              checked={this.state.lights}
                                              onChange={this.switchSelect}
                                            />
                                            <span>
                                              <small></small>
                                            </span>
                                          </label>
                                        </div>
                                        <p
                                          style={{
                                            marginBottom: "5px",
                                          }}
                                        >
                                          Lights
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row justify-content-center">
                                  <div className="col-lg-9 col-md-11 col-sm-12">
                                    <div className="row">
                                      <div className="col-4 p-0 text-left">
                                        <Label>Scan Time</Label>
                                      </div>
                                      <div className="col-8 p-0">
                                        <select
                                          name="scanTime"
                                          className="form-control p-2"
                                          onChange={this.onChange}
                                          value={scanTime}
                                        >
                                          {[
                                            { title: "3 Seconds", value: "3" },
                                            { title: "4 Seconds", value: "4" },
                                            { title: "5 Seconds", value: "5" },
                                            { title: "6 Seconds", value: "6" },
                                            { title: "7 Seconds", value: "7" },
                                            { title: "8 Seconds", value: "8" },
                                            { title: "9 Seconds", value: "9" },
                                            {
                                              title: "10 Seconds",
                                              value: "10",
                                            },
                                            {
                                              title: "11 Seconds",
                                              value: "11",
                                            },
                                            {
                                              title: "12 Seconds",
                                              value: "12",
                                            },
                                            {
                                              title: "13 Seconds",
                                              value: "13",
                                            },
                                            {
                                              title: "14 Seconds",
                                              value: "14",
                                            },
                                            {
                                              title: "15 Seconds",
                                              value: "15",
                                            },
                                            {
                                              title: "16 Seconds",
                                              value: "16",
                                            },
                                            {
                                              title: "17 Seconds",
                                              value: "17",
                                            },
                                            {
                                              title: "18 Seconds",
                                              value: "18",
                                            },
                                            {
                                              title: "19 Seconds",
                                              value: "19",
                                            },
                                            {
                                              title: "20 Seconds",
                                              value: "20",
                                            },
                                            {
                                              title: "21 Seconds",
                                              value: "21",
                                            },
                                            {
                                              title: "22 Seconds",
                                              value: "22",
                                            },
                                            {
                                              title: "23 Seconds",
                                              value: "23",
                                            },
                                            {
                                              title: "24 Seconds",
                                              value: "24",
                                            },
                                            {
                                              title: "25 Seconds",
                                              value: "25",
                                            },
                                            {
                                              title: "26 Seconds",
                                              value: "26",
                                            },
                                            {
                                              title: "27 Seconds",
                                              value: "27",
                                            },
                                            {
                                              title: "28 Seconds",
                                              value: "28",
                                            },
                                            {
                                              title: "29 Seconds",
                                              value: "29",
                                            },
                                            {
                                              title: "30 Seconds",
                                              value: "30",
                                            },
                                            {
                                              title: "31 Seconds",
                                              value: "31",
                                            },
                                            {
                                              title: "32 Seconds",
                                              value: "32",
                                            },
                                            {
                                              title: "33 Seconds",
                                              value: "33",
                                            },
                                            {
                                              title: "34 Seconds",
                                              value: "34",
                                            },
                                            {
                                              title: "35 Seconds",
                                              value: "35",
                                            },
                                            {
                                              title: "36 Seconds",
                                              value: "36",
                                            },
                                            {
                                              title: "37 Seconds",
                                              value: "37",
                                            },
                                            {
                                              title: "38 Seconds",
                                              value: "38",
                                            },
                                            {
                                              title: "39 Seconds",
                                              value: "39",
                                            },
                                            {
                                              title: "40 Seconds",
                                              value: "40",
                                            }
                                          ].map((row, ind) => (
                                            <option key={ind}>
                                              {" "}
                                              {row.title}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row align-items-center">
                                <div className="col-4 col-lg-4 p-0">
                                  <button
                                    disabled={this.state.buttonsDisabled}
                                    onClick={this.setColor}
                                    style={{
                                      border: "none",
                                      background: "transparent",
                                    }}
                                  >
                                    <img
                                      src={setfarbe}
                                      className="w-100 adminBtn"
                                    />
                                  </button>
                                </div>
                                <div className="col-4 col-lg-4 p-0">
                                  <button
                                    onClick={this.setLights}
                                    disabled={this.state.buttonsDisabled}
                                    style={{
                                      border: "none",
                                      background: "transparent",
                                    }}
                                  >
                                    <img
                                      src={licht}
                                      className="w-100 adminBtn"
                                    />
                                  </button>
                                </div>
                                <div className="col-4 col-lg-4 p-0">
                                  <button
                                    onClick={this.resetState}
                                    disabled={this.state.buttonsDisabled}
                                    style={{
                                      border: "none",
                                      background: "transparent",
                                    }}
                                  >
                                    <img
                                      src={resetbtn}
                                      className="w-100 adminBtn"
                                    />
                                  </button>
                                </div>
                              </div>
                              </div>
                            </div>
                      </div>
                    </div>
                  </div>
                </form>
              </Card>
            </div>
          </div>
        </div>
      </>
    );
    let finalContent = this.state.appInterFaceAccess ? appInterface : loginForm ;
    return(
      finalContent
    )
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(AppInterFace);
